// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Invoice_FiscalRequirementsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /subaccounts/invoice_config/fiscal_requirements
 * (also routed as GET /subaccounts/fiscal/requirements).
 *
 * Returns the required fields / capabilities for each configured invoice
 * provider, one row per provider, sourced from the invoice_providers config
 * map in application/config/invoicing.php.
 */
import type { Invoice_FiscalRequirementsRow } from './Invoice_FiscalRequirementsRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Invoice_FiscalRequirementsResponseDados {
providers: Invoice_FiscalRequirementsRow[]
}

export type Invoice_FiscalRequirementsResponse = ApiResponse<Invoice_FiscalRequirementsResponseDados>;

registerResponseContract('Invoice_FiscalRequirementsResponse', {
  providers: {
    type: 'array',
    required: true,
    items: {
      code:          { type: 'string',  required: false },
      name:          { type: 'string',  required: false },
      capabilities:  { type: 'array',   required: false },
      config_schema: { type: 'object',  required: false },
    },
  },
})
